export default "__VITE_ASSET__BZk0AKNr__"